import { motion } from "framer-motion";
import { useCommissionSettings } from "@/features/commission-settings/hooks";
import { useSiteSettings } from "@/features/site-settings/hooks";
import { SEO } from "@/components/seo/SEO";
import { LandingLogo } from "@/pages/home/LandingLogo";
import { PrimaryNavigation } from "@/pages/home/PrimaryNavigation";

const fallbackLogoUrl = "/KL-Logo.png";

export function HomePage() {
  const siteSettings = useSiteSettings();
  const commissionSettings = useCommissionSettings();
  const site = siteSettings.data;
  const commissions = commissionSettings.data;

  return (
    <motion.main
      className="grid min-h-screen overflow-x-hidden bg-black px-3 py-6 text-white sm:px-6 sm:py-10"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <SEO
        title={site?.heroHeading || site?.seoTitle || site?.siteName}
        description={site?.heroSubheading || site?.metaDescription || site?.tagline}
        ogImage={site?.logoUrl || fallbackLogoUrl}
      />
      <section className="mx-auto flex w-full max-w-7xl flex-col items-center justify-center gap-8 sm:gap-14 lg:gap-20">
        <LandingLogo
          siteName={site?.siteName}
          headline={site?.heroHeading}
          subheadline={site?.heroSubheading}
          logoUrl={site?.logoUrl || fallbackLogoUrl}
          isLoading={siteSettings.isLoading}
        />
        <PrimaryNavigation commissionsOpen={commissions?.isOpen ?? true} isLoading={commissionSettings.isLoading} />
      </section>
    </motion.main>
  );
}
